// // The Vue build version to load with the `import` command
// // (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import App from './App'
// import router from './router'

// Vue.config.productionTip = false

// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

import Vue from 'vue'
import App from '@/App.vue'
import {router} from '@/router'

const isProd                   = process.env.NODE_ENV === 'production';
const environment = isProd ? require('../config/prod.env') : require('../config/dev.env');
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: environment.RECAPTCHA_SITEKEY.replaceAll("\"", ""), //Remove quotes to fix recaptcha loading issue with the key.
  loaderOptions: {
    useRecaptchaNet: true
  }})

import auth from '@/auth'
import VueResource from 'vue-resource'

import Axios from 'axios'

//It is important to include the plugin as early as possible.
//Fix bug Internet Explorer unable to load symbol.
//Source : https://vuetifyjs.com/en/getting-started/quick-start
import 'babel-polyfill' 

import Vuetify from 'vuetify'
import VueMaterialIcon from 'vue-material-icon'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

//import BootstrapVue from 'bootstrap-vue'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import "material-icons/css/material-icons.min.css"
import "material-icons/iconfont/material-icons.css"
import "vuetify/dist/vuetify.min.css"
import "vuetify/dist/vuetify.min.js"
import "vuetify/es5/index.js"

Vue.use(VueResource)
Vue.use(BootstrapVue)
//Vue.use(Axios)
Vue.use(Vuetify)
// Vue.use(Vuetify, {
//   theme: {
//     primary: '#3f51b5',
//     secondary: '#b0bec5',
//     accent: '#8c9eff',
//     error: '#b71c1c'
//   }
// });
Vue.use(VueMaterialIcon)

//Vue.component(VueMaterialIcon.VIcon, VueMaterialIcon)

Vue.use(VueMoment, {
  moment,
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
})

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD HH:mm')
  }
})

Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token')

// Check the user's auth status when the app starts
auth.checkAuth()

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// window.$ = require('jquery')
// window.JQuery = require('jquery')

// const { app } = require('electron')
// app.on('ready', () => {
//   // ...
//   if (process.env.NODE_ENV !== 'production') {
//     require('vue-devtools').install()
//   }
//   // ...
// })

// axiosDefault configuration
Axios.defaults.timeout = 300000;   // timeout


// WEBPACK FOOTER //
// ./src/main.js